var _defs, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMeta = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32",
  ref: ref
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "meta_svg__b",
  x1: 8,
  x2: 8,
  y1: 7,
  y2: 23,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#0064e0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#0082fb"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "meta_svg__c",
  x1: 18.5,
  x2: 27,
  y1: 15,
  y2: 12,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#0064e1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#0082fb"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "meta_svg__e",
  x1: 18.4,
  x2: 9.56,
  y1: 16.7,
  y2: 5.11,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.13,
  stopColor: "#0869e1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.87,
  stopColor: "#0064e0"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "meta_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M22.962 5.376c-2.622 0-4.671 1.974-6.527 4.483-2.55-3.246-4.682-4.483-7.233-4.483C4 5.376.014 12.146.014 19.312c0 4.484 2.169 7.312 5.803 7.312 2.615 0 4.496-1.233 7.84-7.078l2.352-4.157q.504.814 1.062 1.754l1.568 2.638c3.054 5.11 4.756 6.843 7.84 6.843 3.54 0 5.51-2.867 5.51-7.444 0-7.503-4.076-13.804-9.027-13.804M11.107 17.963c-2.711 4.25-3.65 5.203-5.158 5.203-1.554 0-2.477-1.364-2.477-3.796 0-5.202 2.594-10.521 5.686-10.521 1.674 0 3.073.967 5.217 4.035-2.035 3.122-3.268 5.08-3.268 5.08m10.231-.534-1.874-3.127A65 65 0 0 0 18 12.023c1.69-2.607 3.083-3.907 4.741-3.907 3.444 0 6.199 5.07 6.199 11.298 0 2.374-.778 3.752-2.389 3.752-1.544 0-2.282-1.02-5.214-5.737"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#meta_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#meta_svg__b)",
  d: "M0 5h16.4v22H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#meta_svg__c)",
  d: "M16.4 5H32v22H16.4z"
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#meta_svg__e)",
  d: "M19.464 14.302c-4.065-6.61-6.77-8.926-10.262-8.926l-.044 3.473c2.286 0 4.059 1.802 7.913 8.294l.235.395z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgMeta);
export default ForwardRef;